import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CultureCenterLoginDirective } from './culture-center-login.directive';
import { MemberLoadingCultureCenterComponent } from './member-loading-culture-center/member-loading-culture-center.component';
import { CultureCenterService } from './cultureCenter.service';
import { GlobalModule } from '@techmore/global';
import { TranslateModule } from '@ngx-translate/core';
import { ShareModule } from 'src/app/share/share.module';


@NgModule({
  declarations: [
    MemberLoadingCultureCenterComponent,
    CultureCenterLoginDirective,
  ],
  imports: [
    CommonModule,
    GlobalModule,
    FormsModule,
    RouterModule,
    TranslateModule.forChild(),
    ShareModule
  ],
  exports: [
    CultureCenterLoginDirective,
  ]
})
export class CultureCenterMemberModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CultureCenterMemberModule,
      providers: [CultureCenterService]
    };
  }
}
